/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       ReservationDetailScreenStyle.ts
 * @author     Christian Ascone
 * @date       12/27/19 10:16 AM
 */

import {Platform, StyleSheet} from "react-native";
import {Header} from "@react-navigation/stack";
import Layout from "../../../config/Layout";

const styles = StyleSheet.create({
    container: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        alignSelf: 'stretch',
        flex: 1,
        backgroundColor: '#fff',
        maxHeight: Layout.window.height - Header.HEIGHT,
        ...Platform.select({
            web:{
                maxHeight: Layout.window.height - Header.HEIGHT,
                minHeight: Layout.window.height - 4*Header.HEIGHT,
            }
        }),
    },
    scroll: {},
    subtitleContainer: {
        flex: 1,
    },
    title: {
        textAlign: 'center',
        fontSize: 20,
    },
    subtitle: {
        fontSize: 15,
    },
    installationContainer: {
        flex: 3,
        flexDirection: 'column',
        marginBottom: 10,
    },
    installationImage: {
        width: 15,
        height: 15,
    },
    installationPlusImage: {
        width: 10,
        height: 10,
        marginHorizontal: 5,
    },
    installationText: {
        marginHorizontal: 40,
    },
    contentContainer: {
        justifyContent: 'space-between',
        margin: 10,
    },
    welcomeContainer: {
        alignSelf: 'stretch',
        flexDirection: 'row',
        flex: 1,
    },
    getStartedContainer: {
        height: '100%',
    },
});

export default styles;